export enum enumDomainOption {
  links = 'links',
  website = 'website',
}

export type IDomainsOptions = enumDomainOption

export enum enumSubdomainOption {
  go = 'go',
  link = 'link',
  i = 'i',
  custom = 'custom',
}

export type ISubdomainsOptions = enumSubdomainOption
